import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import Setup from './Setup';
import Audit from './Audit';
import './GroupEditor.scss';
import LoadingOverlay from '../LoadingOverlay';

function GroupEditor({
  dealers,
  onSubmit,
  history,
  step,
  groupId,
  group,
  tab,
  fetching,
}) {
  const renderStep = useMemo(() => {
    if (!tab || tab === 'setup') {
      return (
        <Setup
          onSubmit={onSubmit}
          dealers={dealers}
          history={history}
          groupId={groupId}
          group={group}
          tab={tab}
          step={step}
        />
      );
    }
    if (tab === 'audit') {
      return (
        <Audit
          configHolderDealerId={group?.configHolderDealerId}
          group={group}
        />
      );
    }
    return null;
  }, [step, dealers, onSubmit, history, groupId, tab, group]);

  return <LoadingOverlay active={fetching}>{renderStep}</LoadingOverlay>;
}

GroupEditor.propTypes = {
  dealers: PropTypes.array,
  onSubmit: PropTypes.func,
  history: PropTypes.object,
  tab: PropTypes.string,
  step: PropTypes.number,
  groupId: PropTypes.string,
  group: PropTypes.object,
  fetching: PropTypes.bool,
};

export default GroupEditor;
